import { type UserBase, getUserName } from 'models';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { routes } from 'routes/routes';
import type { MemberEntityScope } from '../types';
import { useGetMemberBreadcrumbEntityName } from './useGetMemberBreadcrumbEntityName';

export const useGetMemberEntityBreadcrumb = ({
  entityScope,
  member,
}: {
  entityScope: MemberEntityScope;
  member: UserBase;
}) => {
  const { t } = useTranslation();
  const getEntityName = useGetMemberBreadcrumbEntityName();

  return useMemo(
    () => [
      {
        path: routes.members.detail(member.id),
        title: getUserName(member),
      },
      {
        path: routes.members.entities(member.id, entityScope),
        title: t(getEntityName({ entityScope })),
      },
    ],
    [getEntityName, entityScope, member, t],
  );
};
